<template>
  <div>
    <main-layout>
      <div class="pl-4">
        <v-tabs v-model="tab" align-tabs="end" color="white" :slider-color="$vuetify.theme.primary">
          <v-tab
            style="text-transform: capitalize"
            ripple
            @click="updateSlug('UsersGroup')"
            :value="'UsersGroup'"
            >จัดการบทบาท</v-tab
          >
          <v-tab
            style="text-transform: capitalize"
            ripple
            @click="updateSlug('Users')"
            :value="'Users'"
            >สมาชิกแอดมิน</v-tab
          >
        </v-tabs>
      </div>
      <div id="view-content-techhunt">
        <UsersGroup v-if="viewPage == 'UsersGroup'" />
        <Users v-else-if="viewPage == 'Users'" />
        <!-- <Funnel v-else-if="viewPage == 'Funnel'" /> -->
      </div>
    </main-layout>
  </div>
</template>

<script>
// import Dashboard from './Dashboard'
// import Agent from './Agent'
// import Funnel from './Funnel'
import Users from './Users'
import UsersGroup from './UsersGroup'

export default {
  data() {
    return {
      // currentView: 'Users',
      // loading: false,
      viewPage: 'UsersGroup',
    }
  },
  components: {
    // Dashboard,
    // Agent,
    // Funnel,
    Users,
    UsersGroup,
  },
  created() {},
  mounted() {
    this.$store.dispatch('loadAgents')
    this.$store.dispatch('loadAgentGroups')
  },
  methods: {
    updateSlug(view) {
      this.$router.replace({ query: { view } })
      this.viewPage = view
    },
    //   updateRoute: function () {
    //     this.$router.push({
    //       name: 'ticket',
    //       path: '/ticket',
    //       query: {
    //         tab: this.viewPage,
    //       },
    //     })
    //     this.routeValue = JSON.stringify(this.$route.query)
    //   },
    // },
    // watch: {
    //   viewPage: function () {
    //     this.updateRoute()
    //   },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/main.vue